import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { ChartData } from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface LeaseChartData {
  labels: string[];
  values: number[];
}

interface LeaseExpirationChartProps {
  data: LeaseChartData;
}

const LeaseExpirationChart: React.FC<LeaseExpirationChartProps> = ({ data }) => {
  const chartData: ChartData<'bar'> = {
    labels: data?.labels || [],
    datasets: [
      {
        label: 'Number of Leases Expiring',
        data: data?.values || [],
        backgroundColor: '#4285F4', // Normal Blue
        borderColor: '#4285F4', // Normal Blue
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Lease Expirations by Month',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Leases',
        },
      },
    },
  };

  return (
    <div className="h-72 w-full">
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default LeaseExpirationChart;
